import Activity from "../../activity/model/Activity";
import DragContainerModel from "../../ddTxtImg/model/DragContainerModel";
import CompareContainerModel from "./CompareContainerModel";

class CompareActivity extends Activity {
  constructor() {
    super();
    this.activityType = this.COMPARE;
    this.dragContainerModel = new DragContainerModel();
    this.compareContainerModel = new CompareContainerModel();
  }

  initFromJson = (obj) => {
    this.initPublicItemsFromJson(obj);
    this.dragContainerModel.initFromJson(obj.dragContainerModel);
    this.compareContainerModel.initFromJson(obj.compareContainerModel);
  };

  getAsJson = () => {
    let jsCode = this.getPublicItemsAsJson();
    jsCode.dragContainerModel = this.dragContainerModel.getAsJson();
    jsCode.compareContainerModel = this.compareContainerModel.getAsJson();


    return jsCode;
  };

  getReportAsJson = () => {
    let jsCode = {}
    jsCode.activityId = this.activityId
    jsCode.answeredTrue = this.answeredTrue
    jsCode.activityType= this.activityType
    jsCode.compareContainerModel = this.compareContainerModel.getAsJson();


    return jsCode;
  };

  initReportFromJson=(userAns)=>{
    this.activityId = userAns.activityId
    this.answeredTrue = userAns.answeredTrue
    this.compareContainerModel=new CompareContainerModel()
    this.compareContainerModel.initFromJson(userAns.compareContainerModel) 
  }


  initSharedItems = (activityArr) => {
    this.initPublicSharedItem(activityArr);
  };


  initFromJsonTest4You = (obj) => {
    this.initPublicItemsFromJsonTest4You(obj);
    this.readText.tfReadText = "اسحب الاجابة الصحيحة:"
    this.dragContainerModel.initFromJsonTest4YouForCompareConnect(obj.ConnectContainerModel);
    this.compareContainerModel.initFromJsonTest4You(obj.ConnectContainerModel, this.dragContainerModel.dragItemList);
  };


  getAnsweredTrue = () => {


    let { dropItemList } = this.dropItemContainer


    for (let i = 0; i < dropItemList.length; i++) {
        let result = false
        //  console.log(dropItemList[i].dragList)
        for (let j = 0; j < dropItemList[i].dragList.length; j++) {
            if (dropItemList[i].solvedDragItem.dragIndex == dropItemList[i].dragList[j].dragIndex) {
                result = true
            }

        }
        if (!result) {
            this.answeredTrue = false
        }

    }
}
}

export default CompareActivity;
